import { createRouter, createWebHashHistory } from "vue-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import ChatView from '../views/ChatView.vue';
import CommentsView from '../views/CommentsView.vue';
import ResultView from '../views/ResultView.vue';
import LessonView from '../views/LessonView.vue';
import LiveSessionView from '../views/LiveSessionView.vue';
import LiveSessionResultsView from '../views/LiveSessionResultsView.vue';
import LoginView from '../views/LoginView.vue';
import RegisterView from '../views/RegisterView.vue';
import RobotView from '../views/RobotView.vue';
import SessionsView from '../views/SessionsView.vue';
import SignInView from '../views/SignInView.vue';
import storageHelper from 'storage-helper';

const routes = [
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignInView,
  },
  {
    path: '/result/:id',
    name: 'home',
    component: ResultView
  },
  {
    path: '/lesson/:id',
    name: 'lesson',
    component: LessonView
  },
  {
    path: '/chat/:id',
    name: 'chat',
    component: ChatView
  },
  {
    path: '/comments/:email',
    name: 'comments',
    component: CommentsView,
    props: (route: string) => {
      return {
        emailAddress: route.params.email,
        studentId: route.query.studentId,
        teacherViewing: route.query.teacher
      };
    }
  },
  {
    path: '/sessions',
    name: 'sessions',
    component: SessionsView
  },
  {
    path: '/livesession',
    name: 'livesession',
    component: LiveSessionView,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/livesessionresults',
    name: 'livesessionresults',
    component: LiveSessionResultsView,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/robot/:id',
    name: 'robot',
    component: RobotView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    props: (route: string) => ({
        toPath: route.query.q,
        adminPassword: route.query.a
    })
    
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

const getCurrentUser = () => {
  return new Promise((resolve, reject)=>{
    const removeListener = onAuthStateChanged(getAuth(),
    (user)=>{
      removeListener();
      resolve(user);
    },
    reject
  )
  });
}

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record)=>record.meta.requiresAuth)) {
    if(await getCurrentUser()) {
      next()
    }
    else {
      alert("Unauthorized")
      next("/signin?redirect=" + encodeURI(to.fullPath))
    }

  }
  else if ((to.name !== 'login' && to.name !== 'chat' && to.name !=='comments')
          && !storageHelper.getItem('user-password')) {
      console.log('NO PASSWORD FOUND')
      next(`/login?q=${String(to.path)}`);
  }
  else next()
})

export default router
